/** * * Asynchronously loads the component for
QuickRecharge
* */ import { lazyLoad } from "utils/loadable";
export const QuickRecharge = lazyLoad(
  () => import("./index"),
  (module) => module.QuickRecharge
);
